module.exports = __webpack_public_path__ + "assets/0976358fd23c7e5947204d3eb708f23a.png";